export const rolAdmin = 'ROLE_ADMIN';
export const rolUser = 'ROLE_USER';
export const rolComercial = 'ROLE_COMERCIAL';
export const ROLE_GESTOR_ROOMING = 'ROLE_GESTOR_ROOMING';
export const rolGuia = 'ROLE_GUIA';
export const rolKpi = 'ROLE_KPI';
export const rolSuperadmin = 'ROLE_SUPERADMIN';
export const rolStaff = 'ROLE_STAFF';
export const rolManager = 'ROLE_MANAGER';
export const rolTicketera = 'ROLE_TICKETERA';
